import { orange500 } from 'material-ui/styles/colors';
import { nursing500, grey100, grey300, grey800, white } from '../theme/AllocateColors';

const inputHeight = '36px';

export const toggleGrey = {
  thumbStyle: { backgroundColor: grey100 },
  trackStyle: { backgroundColor: grey300 },
};

export const popUpModalStyles = {
  popUpModal: {
    color: grey800,
  },
};

export const tableStyles = {
  headerStyle: {
    color: grey800,
  },
};

export const datePickerStyle = {
  textFieldStyle: {
    backgroundColor: white,
    height: inputHeight,
    borderRadius: 4,
    width: '100%',
    fontSize: 14,
  },

  floatingLabelStyle: {
    color: nursing500,
    left: 8,
    top: 0,
    transform: 'scale(1) translate(0px, 8px)',
  },

  floatingLabelShrinkStyle: {
    transform: 'scale(0.75) translate(0px, 0px)',
  },

  floatingLabelFocusStyle: {
    transform: 'scale(0.75) translate(0px, 0px)',
  },

  fillContainerStyle: {
    width: '100%',
  },

  underlineStyle: {
    bottom: 0,
    borderWidth: 2,
  },

  inputStyle: {
    marginTop: 4,
    paddingLeft: 8,
  },
};

export const paperStyle = {
  padding: 0,
  boxShadow: '0 none',
};

export const common = {
  floatingLabelStyle: {
    color: nursing500,
    left: 8,
    top: 0,
    transform: 'scale(1) translate(0px, 8px)',
  },

  floatingLabelShrinkStyle: {
    transform: 'scale(0.75) translate(0px, 0px)',
  },

  floatingLabelFocusStyle: {
    transform: 'scale(0.75) translate(0px, 0px)',
  },
  underlineStyle: {
    bottom: 0,
    borderWidth: 2,
  },
  errorStyle: {
    bottom: '3px',
    color: orange500,
    fontSize: 11,
  },
};

// Textfield

export const textFieldStyle = {
  style: {
    backgroundColor: white,
    height: inputHeight,
    borderRadius: 4,
    width: '100%',
    fontSize: 14,
  },

  errorStyle: {
    bottom: '-5px',
    color: orange500,
  },

  displayBlock: {
    display: 'block',
    height: inputHeight,
    backgroundColor: grey100,
    borderRadius: 2,
    fontSize: 14,
  },

  underlineStyle: {
    bottom: 0,
    borderWidth: 2,
    borderColor: grey300,
  },

  underlineFocusStyle: {
    borderColor: nursing500,
    borderWidth: 2,
  },

  validationColor: 'none',

  floatingLabelStyle: {
    color: nursing500,
    left: 8,
    top: 0,
    transform: 'scale(1) translate(0px, 8px)',
  },

  floatingLabelShrinkStyle: {
    transform: 'scale(0.75) translate(0px, 0px)',
  },

  floatingLabelFocusStyle: {
    transform: 'scale(0.75) translate(0px, 0px)',
  },

  inputStyle: {
    marginTop: 0,
    paddingLeft: 8,
    paddingTop: 4,
  },
};

export const multiLineText = {
  style: {
    backgroundColor: grey100,
    borderRadius: 2,
    width: 'auto',
  },
  inputStyle: {
    padding: '0 8px',
  },
  underlineStyle: {
    left: 0,
  },
  underlineFocusStyle: {
    left: 0,
  },
  validationColor: 'none',
};

export const tabStyles = {
  tabItemContainerStyle: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid',
    borderBottomColor: 'transparent',
    borderRadius: '4px',
  },
  inkBarStyle: {
    backgroundColor: '#00B1EB',
  },
  buttonStyle: {
    color: '#00B1EB',
    textTransform: 'none',
    height: '36px',
    width: 'auto',
    margin: '0 1px',
  },
  ripple: {
    color: 'red',
  },
};

export const raisedButtonStyle = {
  labelStyle: {
    textTransform: 'none',
  },

  labelStyleSecondary: {
    textTransform: 'none',
    color: grey800,
  },
};

// Dropdown

export const dropDownStyle = {
  textFieldStyle: {
    backgroundColor: white,
    height: inputHeight,
    borderRadius: 4,
    width: '100%',
    fontSize: 14,
  },

  style: {
    backgroundColor: white,
    height: inputHeight,
    borderRadius: 2,
    fontSize: 14,
    width: '100%',
  },

  menuStyle: {
    marginTop: 0,
    fontSize: 14,
  },

  labelStyle: {
    lineHeight: '46px',
    height: inputHeight,
    margin: 0,
    top: 0,
    paddingLeft: 8,
  },

  labelStyleNonFormsy: {
    lineHeight: '46px',
    height: inputHeight,
    margin: 0,
    top: 0,
    paddingLeft: 0,
  },

  iconStyle: {
    top: 0,
    padding: '4px',
    width: '36px',
    height: '36px',
    fill: '#666666',
  },

  menuItemStyle: {
    fontSize: 14,
  },

  errorStyle: {
    bottom: '-8px',
    color: orange500,
    fontSize: 11,
  },
};

export const autoComp = {
  style: {
    backgroundColor: grey100,
    borderRadius: 2,
  },

  textFieldStyle: {
    backgroundColor: grey100,
    height: inputHeight,
    borderRadius: 4,
    width: '100%',
    fontSize: 14,
  },

  listStyle: {
    maxHeight: '350px',
    overflowY: 'auto',
  },

  inputStyle: {
    marginTop: 6,
    paddingLeft: 8,
  },

  labelStyle: {
    lineHeight: '36px',
    height: inputHeight,
    margin: 0,
    top: 0,
    paddingLeft: 0,
  },
};

export const chipsStyle = {
  style: {
    margin: '5px 5px 0 0',
  },
};

export const PopoverStyle = {
  style: {
    top: '50px',
    background: '#ff0000',
  },

  PaperProps: {
    background: '#ff0000',
  },
};

export const textFieldStyleSmall = {
  errorStyle: {
    color: orange500,
  },
  underlineStyle: {
    bottom: 0,
    borderWidth: 2,
    borderColor: 'grey300',
  },

  underlineFocusStyle: {
    borderColor: nursing500,
    borderWidth: 2,
  },

  validationColor: 'none',

  floatingLabelStyle: {
    color: nursing500,
    left: 8,
    transform: 'scale(1) translate(0px, -30px)',
  },
  floatingLabelFocusStyle: {
    transform: 'scale(0.70) translate(0px, -50px)',
  },
  floatingLabelShrinkStyle: {
    transform: 'scale(0.70) translate(0px, -50px)',
  },
  inputStyle: {
    marginTop: 5,
    paddingLeft: 8,
  },
  style: {
    backgroundColor: grey100,
    height: 36,
    borderRadius: 2,
    margin: 10,
  },
};
